import { fetchAndSaveQueryPreview } from './actions/fetch-and-save-query-preview.action';
import { fetchQueryPreview } from './actions/fetch-query-preview.action';

export const queriesPreviewCustomStoreModule = {
  actions: {
    fetchQueryPreview,
    fetchAndSaveQueryPreview
  }
};
